import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./BodyTypeSearch.style.css";

import citadine  from "../assets/bodytypes/compact_2x_car.webp";
import suv       from "../assets/bodytypes/suv_2x_car.webp";
import pickup    from "../assets/bodytypes/transport_2x_car.webp";
import cabriolet from "../assets/bodytypes/convertible_2x_car.webp";
import monospace  from "../assets/bodytypes/van_2x_car.webp";
import berline    from "../assets/bodytypes/sedan_2x_car.webp";
import breakCar   from "../assets/bodytypes/station-wagon_2x_car.webp";
import coupe      from "../assets/bodytypes/coupe_2x_car.webp";

export const BodyTypeSearch = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const bodyTypes = [
    { name: t("citadine"),     value: 8, image: citadine },
    { name: t("suv"),          value: 2, image: suv },
    { name: t("pickup"),       value: 7, image: pickup },
    { name: t("convertible"),  value: 5, image: cabriolet },
    { name: t("minivan"),      value: 6, image: monospace },
    { name: t("sedan"),        value: 1, image: berline },
    { name: t("stationWagon"), value: 4, image: breakCar },
    { name: t("coupe"),        value: 3, image: coupe },
  ];

  return (
    <section className="bts">
      <div className="bts__inner">
        <div className="bts__head">
          <span className="bts__label">{t("browseBy")}</span>
          <h2 className="bts__title">{t("searchByBodyType")}</h2>
        </div>

        <div className="bts__grid">
          {bodyTypes.map((type, i) => (
            <div
              key={i}
              className="bts__card"
              onClick={() => type.value && navigate(`/featured-cars?bodyTypeid=${type.value}`)}
            >
              <img src={type.image} alt={type.name} />
              <span className="bts__card-name">{type.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
